import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedNumber, FormattedMessage } from 'react-intl'
import Products from '../lib/products'
import Utils from '../lib/utils'

class passTypesSelector extends Component {

  constructor(props) {
    super(props)
    this.openPriceModal = props.openPriceModal.bind(this)
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)
  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  products() {
    const { ageCategory, type, omitIds } = this.props
    return Products
      .filter(p => p.type === type &&
        (!ageCategory ? true : p.ageCategory === ageCategory) &&
        !omitIds.includes(p.id)
      )
  }

  price(product) {
    const { skus } = this.props
    return Utils.getSkuPrice(product.id, 'skuId', skus)
  }

  discountedPrice(product) {
    const { discountedItems, couponInfo } = this.props

    if (!discountedItems && !couponInfo) {
      return this.price(product)
    }
    
    const discountedItem = discountedItems.find(item => item.id === product.id)
    if (discountedItem) {
      return this.price(product) - discountedItem.cashOff
    }
    return couponInfo
      ? this.price(product) * (1 - couponInfo.percent_off / 100)
      : this.price(product)
  }

  render() {
    const { props } = this
    const { intl, passType, skus, onSelect, couponInfo, type, discountedItems, personErrors } = props
    
    return (
      <div className="flex flex-wrap">
        { this.products().sort((a, b) => this.price(a) - this.price(b)).map((product) => (
          <div key={this.getKey()} className={`relative w-full ${this.products().length % 3 === 0 || ['bulk', 'fixedAmount'].includes(type) ? 'md:w-1/3' : 'md:w-1/2' }`}>
            <button
              id="passType"
              name="passType"
              type="button"
              key={this.getKey()}
              onClick={() => onSelect('passType', product.id)}
              className={`${product.id === passType ? 'text-harbor' : 'text-grey-dark'} w-full flex text-left mt-6 focus:outline-none`}
            >
              <div className={`custom-radio flex rounded-full border border-grey-dark bg-white min-w-6 h-6 mr-2 items-center justify-center ${personErrors && personErrors.passType && 'border-red'}`}>
                { product.id === passType && (
                  <div className="rounded-full bg-harbor w-3 h-3" />
                )}
              </div>
              <div>
                <h5>
                  {props.intl.formatMessage({
                    id: `passTypes.${product.id}`
                  }).split(" - ")[0]}
                  {props.intl.formatMessage({id: `passTypes.${product.id}`}).split(" - ")[1] && (
                    <span className="text-sky">
                      &nbsp;-&nbsp;
                      {props.intl.formatMessage({
                        id: `passTypes.${product.id}`
                      }).split(" - ")[1]}
                    </span>
                  )}
                </h5>
                
                {skus.length > 0 && (
                  <>
                    <div className="flex">
                      <div>
                        {(couponInfo || this.discountedPrice(product) !== this.price(product)) && (
                          <div className="flex items-center">      
                            <span className="rounded-full px-2 py-1 mb-1 bg-grass text-harbor font-bold text-xs">
                              {!couponInfo && discountedItems && (
                                <>
                                  -
                                  <FormattedNumber
                                    minimumFractionDigits={discountedItems.find(d => d.id === product.id).cashOff % 1 === 0 ? 0 : 2}
                                    maximumFractionDigits={discountedItems.find(d => d.id === product.id).cashOff % 1 === 0 ? 0 : 2}
                                    value={discountedItems.find(d => d.id === product.id).cashOff}
                                  />
                                  &nbsp;kr.
                                </>
                              )} 
                              {couponInfo && `-${couponInfo.percent_off}%`}
                            </span>
                            &nbsp;&nbsp;
                            <span className="line-through">
                              <FormattedNumber
                                minimumFractionDigits={2}
                                value={this.price(product)}
                              />
                              &nbsp;kr.
                            </span>
                          </div>
                        )}
                        
                        <h2 className="flex m-0">
                          <FormattedNumber
                            minimumFractionDigits={2}
                            value={this.discountedPrice(product)}
                          />
                          &nbsp;kr.
                        </h2>
                      </div>
                    </div>
                    {type === 'pass' && (
                      <div className="text-xs">
                        <FormattedMessage id="passTypes.hourlyRate" defaultMessage="Hourly rate" />
                        &nbsp;
                        <FormattedNumber
                          minimumFractionDigits={2}
                          value={Utils.getSkuPrice(product.id, 'hourRateWeekdaysSkuId', skus)}
                        />
                        &nbsp;kr.
                        {Utils.getSkuPrice(product.id, 'hourRateWeekdaysSkuId', skus) !== Utils.getSkuPrice(product.id, 'hourRateWeekendsSkuId', skus) && (
                          <span className="text-sky">
                            &nbsp;- weekend&nbsp;
                            <FormattedNumber
                              minimumFractionDigits={2}
                              value={Utils.getSkuPrice(product.id, 'hourRateWeekendsSkuId', skus)}
                            />
                            &nbsp;kr.
                          </span>
                        )}

                        {/* 
                        <div>
                          {React.createElement('span', {}, '+')}
                          { Utils.useDailyInsurance(product.id)
                            ? `${Utils.getSkuPrice('insurance', 'mandatoryDailySkuId', skus)} kr. ${intl.formatMessage({ id: 'passTypes.insuranceDaily', defaultMessage: 'insurance, daily' })}`
                            : `${Utils.getSkuPrice('insurance', 'mandatoryYearlySkuId', skus)} kr. ${intl.formatMessage({ id: 'passTypes.insuranceAnnual', defaultMessage: 'insurance, annual'})}`}
                        </div>
                        */}
                      </div>
                    )}
                  </>
                )}

                {!!props.intl.messages[`passTypes.${product.id}Desc`] && (
                  <div className="text-xs" style={{whiteSpace: 'pre-wrap'}}>
                    {props.intl.formatMessage({
                      id: `passTypes.${product.id}Desc`
                    }).replace(/<br>/g, '\n')}
                  </div>
                )}
              </div>
            </button>
            
            {type === 'pass' && (
              <button
                onClick={this.openPriceModal}
                type="button"
                key={this.getKey()}
                className={`absolute pin-t pin-r ${this.products().length % 3 === 0 ? 'mr-12' : 'mr-32'} mt-6 xl:mt-12 rounded-full min-w-6 h-6 bg-sky flex items-center justify-center text-white text-sm`}
              >
                i
              </button>
            )}           
          </div>
        ))}
      </div>
    )
  }
}


passTypesSelector.propTypes = {
  type: PropTypes.string,
  ageCategory: PropTypes.string.isRequired,
  openPriceModal: PropTypes.func.isRequired,
  omitIds: PropTypes.arrayOf(PropTypes.number),
  skus: PropTypes.instanceOf(Array).isRequired
}

passTypesSelector.defaultProps = {
  type: 'pass',
  omitIds: []
}

export default injectIntl(passTypesSelector)